"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
var react_1 = __importDefault(require("react"));
var AppBar_1 = __importDefault(require("@material-ui/core/AppBar"));
var Box_1 = require("../components/Box");
var system_1 = require("../system");
var utils_1 = require("../utils");
var useStyles = (0, system_1.makeStyles)(function (theme) { return ({
    root: {
        height: theme.go.schemes.components.header.height,
        backgroundColor: theme.go.schemes.colors.system.BgMain,
        borderBottom: "1px solid ".concat(theme.go.schemes.colors.system.Divider),
        display: 'flex',
        boxSizing: 'border-box',
        '& *': {
            boxSizing: 'border-box',
        },
    },
    header: {
        width: '100vw',
    },
}); });
exports.Header = react_1.default.forwardRef(function (_a, ref) {
    var classes = _a.classes, children = _a.children, props = __rest(_a, ["classes", "children"]);
    var _b = useStyles(), root = _b.root, header = _b.header;
    return (react_1.default.createElement(AppBar_1.default, __assign({}, props, { ref: ref, classes: __assign(__assign({}, classes), { root: (0, utils_1.cn)(root, classes === null || classes === void 0 ? void 0 : classes.root) }), elevation: 0 }),
        react_1.default.createElement(Box_1.Box, { alignItems: "center", pl: "L", pr: "L", flexGrow: 1, className: header }, children)));
});
